module.exports = Em.View.extend({
    templateName: 'quote/edit'
})
